// extracted by mini-css-extract-plugin
module.exports = {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","MenuItem":"ze_a bag_sr bag_cw bag_a","MenuItem__Btn":"ze_b bag_z"};